import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import Loading from "../../../../components/loading";
import "./styles/aparelhosAutonomosInfo.css";

export function AparelhosAutonomosInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [newData, setNewData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getRealizadosAparelhosAutonomosById(
                    id,
                    config
                ).then((res) => {
                    setNewData(res);
                });
                await Requests.putAllDtFinalAparelhos(config).then((res) => {
                    return res;
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    const conditionAcao = (check) => {
        if (check.acao === "") {
            return <span>Não há ação</span>;
        } else {
            return check.acao;
        }
    };

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const consitionConforma = (check) => {
        if (check === 0) return "Não";
        return "Sim";
    };

    return (
        <div>
            <div className="info-container">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">Aparelhos Autônomos</h1>
                </div>
                <div className="data-grid-container">
                    {isLoading ? (
            <Loading isLoading={isLoading} />
          ) : (
            newData.map((check, i) => {
                        return (
                            <main className="datagrid-container">
                                <div className="table-content">
                                    <div key={i}>
                                        <thead>
                                            <tr>
                                                <th>Data de inspeção</th>
                                                <th>Data limite de inspeção</th>
                                                <th>Ação</th>
                                                <th>Classificação</th>
                                                <th>Prazo</th>
                                                <th>Data de conclusão</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <td>
                                                {formatDate(
                                                    check.data_inspecao
                                                )}
                                            </td>
                                            <td>{formatDate(
                                                    check.aparelho
                                                        .dt_limite_inspecao
                                                )}</td>
                                            <td>{conditionAcao(check)}</td>
                                            <td>{check.classificacao}</td>
                                            <td>{formatDate(check.prazo)}</td>
                                            <td>{formatDate(check.data_conclusao)}</td>
                                        </tbody>
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div key={i}>
                                        <thead>
                                            <tr>
                                                <th>Registro fotográfico</th>
                                                <th>Último teste</th>
                                                <th>Próximo teste</th>
                                                <th>
                                                    Vencimento cilindro de ar
                                                </th>
                                                <th>Conforme</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <td>{check.fotos.length}</td>
                                            <td>{
                                                check.aparelho
                                                    .dt_teste_hidro_ultima_mes
                                            }
                                            /
                                            {
                                                check.aparelho
                                                    .dt_teste_hidro_ultima_ano
                                            }</td>
                                            <td>{
                                                check.aparelho
                                                    .dt_validade_teste_hidro_mes
                                            }
                                            /
                                            {
                                                check.aparelho
                                                    .dt_validade_teste_hidro_ano
                                            }</td>
                                            <td>{formatDate(
                                                check.aparelho.venc_cilindro_ar
                                            )}</td>
                                            <td>{consitionConforma(
                                                check.conformidade
                                            )}</td>
                                        </tbody>
                                    </div>
                                </div>
                            </main>
                        );
                    }))}
                
                </div>
            </div>
        </div>
    );
}
